import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import CreditImpotPage from './pages/CreditImpotPage';
import DevisPage from './pages/DevisPage';
import RendezVousPage from './pages/RendezVousPage';
import ContactPage from './pages/ContactPage';
import ZonePage from './pages/ZonePage';
import AdminPage from './pages/AdminPage';
import MentionsLegalesPage from './pages/MentionsLegalesPage';
import PolitiqueConfidentialitePage from './pages/PolitiqueConfidentialitePage';
import CookiesPage from './pages/CookiesPage';
import CookieBanner from './components/CookieBanner';
import MusicPlayer from './components/MusicPlayer';
import NotreVisionPage from './pages/NotreVisionPage';
import TemoignagesPage from './pages/TemoignagesPage';
import PtitconseilsPage from './pages/PtitconseilsPage';
import AgencyPage from './pages/AgencyPage';
import CityPage from './pages/CityPage';
import CitiesIndexPage from './pages/CitiesIndexPage';
import ConseilPage from './pages/ConseilPage';
import DevenirEaserPage from './pages/DevenirEaserPage';
import NotFoundPage from './pages/NotFoundPage';
import ServiceCityPage from './pages/ServiceCityPage';
import ServiceHubPage from './pages/ServiceHubPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import ChouetteApprentissagePage from './pages/ChouetteApprentissagePage';
import FloatingContact from './components/FloatingContact';
import EaserTab from './components/EaserTab';
import EaserPage from './pages/EaserPage';
import ClientPage from './pages/ClientPage';
import AnalyticsTracker from './components/AnalyticsTracker';
import { AGENCIES } from './lib/agencies-data';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

/** Full-screen areas (employee / client portals, back-office) render without the public site header/footer. */
const isStandalone = (pathname) => pathname.startsWith('/easer') || pathname.startsWith('/client') || pathname.startsWith('/admin');

function SiteHeader() {
  const { pathname } = useLocation();
  return isStandalone(pathname) ? null : <Header />;
}

function SiteFooter() {
  const { pathname } = useLocation();
  return isStandalone(pathname) ? null : <Footer />;
}

function App() {
  return (
    <HelmetProvider>
    <Router>
      <ScrollToTop />
      <AnalyticsTracker />
      <div className="min-h-screen flex flex-col">
        <SiteHeader />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/easer" element={<EaserPage />} />
            <Route path="/client" element={<ClientPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/:serviceId" element={<ServiceDetailPage />} />
            <Route path="/credit-impot" element={<CreditImpotPage />} />
            <Route path="/devis" element={<DevisPage />} />
            <Route path="/rendez-vous" element={<RendezVousPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/zone-intervention" element={<AgencyPage agency={AGENCIES['artois.ptitservices']} />} />
            <Route path="/agence/artois.ptitservices" element={<AgencyPage agency={AGENCIES['artois.ptitservices']} />} />
            <Route path="/notre-vision" element={<NotreVisionPage />} />
            <Route path="/chouette-apprentissage" element={<ChouetteApprentissagePage />} />
            <Route path="/temoignages" element={<TemoignagesPage />} />
            <Route path="/ptitconseils" element={<PtitconseilsPage />} />
            <Route path="/ptitconseils/:slug" element={<ConseilPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/services-a-domicile" element={<CitiesIndexPage />} />
            <Route path="/services-a-domicile/:citySlug" element={<CityPage />} />
            <Route path="/menage-a-domicile/:citySlug" element={<ServiceCityPage serviceKey="menage" />} />
            <Route path="/jardinage-a-domicile/:citySlug" element={<ServiceCityPage serviceKey="jardinage" />} />
            <Route path="/taille-de-haies" element={<ServiceHubPage serviceKey="taille-haies" />} />
            <Route path="/taille-de-haies/:citySlug" element={<ServiceCityPage serviceKey="taille-haies" />} />
            <Route path="/menage-a-domicile" element={<Navigate to="/services/entretien-menager" replace />} />
            <Route path="/jardinage-a-domicile" element={<Navigate to="/services/espaces-verts" replace />} />
            <Route path="/devenir-easer" element={<DevenirEaserPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
            <Route path="/politique-confidentialite" element={<PolitiqueConfidentialitePage />} />
            <Route path="/cookies" element={<CookiesPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <SiteFooter />
      </div>
      <CookieBanner />
      <MusicPlayer />
      <FloatingContact />
      <EaserTab />
      <Toaster position="top-right" richColors />
    </Router>
    </HelmetProvider>
  );
}

export default App;
